import { Catalog } from '@df/catalog/catalog.interfaces';
import { IAddToBasketData } from '@df/session/api/basket/basket';
import { LocalBasketItem } from '../../customer/basket/basket-item.decorator';
export namespace BasketAddNotice {
    export const basketAddNoticeModalId = 'basket-add-notice-modal';
    export interface IModalData {
        basketItem: LocalBasketItem;
        request: IAddToBasketData;
        addedItemsQty: number;
        giftItem?: LocalBasketItem;
    }
    /**
     * Modal bLock data
     */
    export type IBlockData = Catalog.IBlockData<IBlockContent>;
    /**
     * Modal block content
     */
    export interface IBlockContent {
        klevu_recommendations_id?: string;
    }
}
